import debounce from 'debounce';
import select from 'dom-select';

export const figure = (el) => {
  const ui = {
    el,
    image: select('img.image', el),
  };

  const debouncedCheckImageWidth = debounce(() => {
    checkImageWidth();
  }, 150);

  const checkImageWidth = () => {
    if (!ui.image) return;

    const imageContainer = ui.image.parentElement || ui.el;
    const containerWidth = imageContainer.getBoundingClientRect().width;
    const imageNaturalWidth = ui.image.naturalWidth;
    const isSkinnyImage = imageNaturalWidth > 0 && imageNaturalWidth < containerWidth;

    ui.el.classList.toggle('figure--skinny-image', isSkinnyImage);

    if (isSkinnyImage) {
      ui.el.style.maxWidth = `${imageNaturalWidth}px`;
    }
  };

  const checkImageWidthWhenReady = () => {
    if (!ui.image) return;

    if (ui.image.complete) {
      checkImageWidth();
      return;
    }

    // wait until the image is fully decodable before measuring it
    ui.image.decode()
      .then(checkImageWidth)
      .catch(() => {
        ui.image.addEventListener('load', checkImageWidth, { once: true });
      });
  };

  const addEvents = () => {
    checkImageWidthWhenReady();
    window.addEventListener('resize', debouncedCheckImageWidth);
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default figure;
